import StudentItem from "../StudentItem";
import SearchBar from "../../SearchBar";
import { SelectSorting } from "./SelectSorting";
import { useGroupManager } from "../../../hooks/useGroupManager";

export default function NoGroupSection() {
  const {
    selectedStudentNoGroup,
    setSelectedStudentNoGroup,
    sortedStudentsNoGroup,
    searchTerm,
    setSearchTerm,
    order,
    setOrder,
  } = useGroupManager();

  return (
    <section className="lg:w-[25vw] sm:w-[30vw]  max-sm:w-full h-[60vh] border border-black  overflow-y-scroll bg-primary-yellow">
      <div className="flex gap-2 sticky top-0 bg-primary-yellow p-1 max-h-14">
        <SearchBar search={searchTerm} setSearch={setSearchTerm} />
        <SelectSorting order={order} setOrder={setOrder} />
      </div>

      {sortedStudentsNoGroup.map((student) => (
        <StudentItem
          studentName={`${student.surname} ${student.name}`}
          studentId={student.id}
          setSelectedStudent={setSelectedStudentNoGroup}
          selectedStudent={selectedStudentNoGroup}
          key={student.id}
          purpose={"add"}
        />
      ))}
    </section>
  );
}
